export default __webpack_public_path__ + "static/media/american-express.3b91c320.png";